import { createStore } from 'vuex';

export default createStore({
  state: {
    payjp: null
  },
  mutations: {
    setPayjp (state, payjp) {
      state.payjp = payjp;
    }
  },
  actions: {
  },
});
